import React, { useState, useEffect, useRef } from "react";
import env from "@beam-australia/react-env";

import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import useSkeleton from "../../../../hooks/useSkeleton";
import useApi from "../../../../hooks/useApi";
import useCRUDService from "../../../../hooks/useCRUDService";
import Layout from "../../../../layout/layout";

import { loadingState } from "../../../../states/loadingState";

import { SelectButton } from "primereact/selectbutton";
import { Button } from "primereact/button";


import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import "./calculator.css";


const Calculator = ({ settings = {} }) => {
  // Protección para evitar múltiples montajes accidentales
  const mountedRef = useRef(false);
  const navigate = useNavigate();
  const s = useSkeleton("abm");
  const api = useApi();
  const clientsCRUDService = useCRUDService("clients");
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useAtom(loadingState);
  const [installmentsAmount, setInstallmentsAmount] = useState();
  const [valueAmount, setValueAmount] = useState();
  const [valueInstallmentsNumber, setValueInstallmentsNumber] = useState();
  const [amountsOptions, setAmountsOptions] = useState([]);
  const [installmentsOptions, setInstallmentsOptions] = useState([]);

  console.log("hasOpenCredits", localStorage.getItem("hasOpenCredits"));

  console.log(localStorage.getItem("hasOpenCredits") == "true")

  // Fetch client config and set options only once
  useEffect(() => {
    if (mountedRef.current) return;
    mountedRef.current = true;
    const fetchData = async () => {
      try {
        const client = await clientsCRUDService.getEntity(
          localStorage.getItem("clientId"),
          "base"
        );

        console.log("Client data:", client);
        const sortedAmounts = [...client.clientsInstallmentsAmountsCollection].sort((a, b) => a.installmentAmount - b.installmentAmount);
        const sortedNumbers = [...client.clientsInstallmentsNumbersCollection].sort((a, b) => a.installmentNumber - b.installmentNumber);

        setAmountsOptions(
          sortedAmounts.map((element) => ({
            label: element.installmentAmount.toLocaleString("es-UY", {
              style: "currency",
              currency: "UYU",
            }),
            value: element,
          }))
        );
        setInstallmentsOptions(sortedNumbers.map((element) => element.installmentNumber));
      } catch (error) {
        if (settings.toast && settings.toast.current && typeof settings.toast.current.show === "function") {
          settings.toast.current.show({
            severity: "error",
            summary: "Error",
            detail: t("errors.general"),
            life: 3000,
          });
        }
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Calculate installment amount when valueAmount and valueInstallmentsNumber change
  useEffect(() => {
    const getInstallmentAmount = async () => {
      if (valueAmount && valueInstallmentsNumber) {
        setIsLoading(true);
        try {
          const response = await api.get(
            `${env("API_URL")}/website/GetInstallmentAmount`,
            {
              params: {
                amount: valueAmount.installmentAmount,
                installments: valueInstallmentsNumber,
                beneficiaryId: localStorage.getItem("userId"),
              },
            }
          );
          setInstallmentsAmount(response.data);
        } catch (error) {
          if (settings && settings.toast && settings.toast.current && typeof settings.toast.current.show === "function") {
            settings.toast.current.show({
              severity: "error",
              summary: "Error",
              detail: t("errors.general"),
              life: 3000,
            });
          } else {
            // fallback: opcionalmente usar alert o ignorar
            // alert(t("errors.general"));
          }
        } finally {
          setIsLoading(false);
        }
      } else {
        setInstallmentsAmount(undefined);
      }
    };
    getInstallmentAmount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valueAmount, valueInstallmentsNumber]);

  const toAddInfo = () => {
    if (!valueAmount || !installmentsAmount || !valueInstallmentsNumber) return;
    const application = {
      amount: valueAmount.installmentAmount,
      installmentAmount: installmentsAmount,
      installmentNumber: valueInstallmentsNumber,
    };
    navigate("/addInfoAndConfirmApplication", {
      state: application,
    });
  };

  return (
    <React.Fragment>
      <Layout>
        <div className="calculator-container">
          <div style={{ textAlign: "center", marginBottom: "1.5rem" }}>
            <h2 style={{ marginBottom: 8 }}>{ localStorage.getItem("hasOpenCredits") == "true" ? "Renová tu crédito" : "Simulá tu crédito"  }</h2>
            <p style={{ margin: 0, color: "#2a3b4d" }}>
              Seleccioná monto y número de cuotas para calcular el crédito a medida para vos.
            </p>
          </div>
          <div style={{ marginBottom: 24 }}>
            <div className="flex flex-column align-items-center " style={{ marginBottom: 20 }}>
              <h2 style={{ fontSize: 18, marginBottom: 8 }}>{t("entities.applications.amount")}</h2>
              <div className="centered-row">
                <SelectButton
                  id="amount"
                  options={amountsOptions}
                  optionLabel="label"
                  optionValue="value"
                  value={valueAmount}
                  onChange={(e) => {
                    if (e.value) setValueAmount(e.value);
                  }}
                  className={"amount"}
                  style={{ width: "100%", maxWidth: 320 }}
                />
              </div>
            </div>
            <div className="flex flex-column align-items-center" style={{ marginBottom: 20 }}>
              <h2 style={{ fontSize: 18, marginBottom: 8 }}>{t("entities.applications.installmentsNumber")}</h2>
              <div className="centered-row">
                <SelectButton
                  id="installmentsNumber"
                  options={installmentsOptions}
                  value={valueInstallmentsNumber}
                  onChange={(e) => {
                    if (e.value) setValueInstallmentsNumber(e.value);
                  }}
                  className={"amount"}
                  style={{ width: "100%", maxWidth: 320 }}
                />
              </div> 
            </div>
            {installmentsAmount && (  
              <div className="field">
                {/* { localStorage.getItem("hasOpenCredits") == "true"  && (
                <div className="flex justify-content-center align-items-center text-center mb-1">
                  <p>
                    {`El capital amortizado hasta el momento es de ${installmentsAmount.toLocaleString("es-UY", {
                      style: "currency",
                      currency: "UYU",
                    })}`}
                    <br/><br/>
                    {`El saldo de capital restante es de ${installmentsAmount.toLocaleString("es-UY", {
                      style: "currency",
                      currency: "UYU",
                    })}`}
                  </p>`
                </div>
                )} */}
                <div className="resultBox mb-1">
                  <h2>
                    {`Tu cuota mensual queda en ${installmentsAmount.toLocaleString("es-UY", {
                      style: "currency",
                      currency: "UYU",
                    })}`}
                  </h2>
                </div>
                <span className="alert_info">
                  <FontAwesomeIcon
                    icon={faCircleInfo}
                    style={{ paddingRight: "5px" }}
                  />
                  Se incluye en el valor de la cuota un 1% por costos administrativos.
                </span>
                <div style={{ width: "100%" }}>
                  <Button
                    onClick={toAddInfo}
                    label="Solicitalo ya"
                    className="button_colorSecuritas"
                    loading={isLoading}
                    style={{ width: "100%", marginTop: "10px" }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </Layout>
    </React.Fragment>
  );
};

export default Calculator;
